import { IkeCloneable, IkeFieldType } from '@ikegps/core-api';
import { FormModelField, FormModelFieldNestedList, FormModelFieldSubForm } from '../..';
import { IkeId } from '../../../id';
import { getOtherAssignedSubformFieldIds } from '../subform/form.subform.field.util';

export function isValidDefaultOwnerField(field: FormModelField): boolean {
	if (!isValidOwnerField(field) || !FormModelFieldNestedList.isNestedList(field)) {
		return false;
	}

	const options = field.options;
	const [option1, option2] = options.values;
	if (!option1 || !option2 || !options || options.title !== 'Industry' || options.values.length < 2) {
		return false;
	}

	if (
		option1.value !== 'UTILITY' ||
		!option1.options ||
		option1.options.title !== 'Owner Id' ||
		option1.options.values.length < 1
	) {
		return false;
	}
	if (!option1.options.values[0] || option1.options.values[0].value !== 'Power') {
		return false;
	}

	if (
		option2.value !== 'COMMUNICATION' ||
		!option2.options ||
		option2.options.title !== 'Owner Id' ||
		option2.options.values.length < 4
	) {
		return false;
	}
	const option2Values = option2.options.values.map((v) => v.value);
	return (
		option2Values[0] === 'CATV' &&
		option2Values[1] === 'Telco' &&
		option2Values[2] === 'Fiber' &&
		option2Values[3] === 'Unknown'
	);
}

export function isValidOwnerField(field: FormModelField): boolean {
	if (field.type !== IkeFieldType.NESTED_LIST) {
		return false;
	}
	const anchorOwnerFieldId = field.parent?.stateValue.anchorTypeState?.ownerFieldId;
	const equipmentOwnerFieldId = field.parent?.stateValue.equipmentTypeState?.ownerFieldId;
	const otherIds = getOtherAssignedSubformFieldIds(field, anchorOwnerFieldId, equipmentOwnerFieldId);
	return !otherIds.includes(field.id);
}

export function addOwnerField(field: FormModelFieldSubForm, index?: number) {
	const ownerField = field.createField<FormModelFieldNestedList>(
		IkeFieldType.NESTED_LIST,
		{
			id: IkeId.generate(),
			displayName: 'Owner',
			locked: false,
			isGenerated: true,
		},
		index
	);

	const builder = ownerField.Mutator.builder;
	const industryGroup = builder.createGroup('Industry');

	const utilityOption = industryGroup.createValue('UTILITY');
	const utilityOwnerIdGroup = utilityOption.createGroup('Owner Id');
	utilityOwnerIdGroup.createValue('Power');

	const communicationOption = industryGroup.createValue('COMMUNICATION');
	const communicationOwnerIdGroup = communicationOption.createGroup('Owner Id');
	communicationOwnerIdGroup.createValue('CATV');
	communicationOwnerIdGroup.createValue('Telco');
	communicationOwnerIdGroup.createValue('Fiber');
	communicationOwnerIdGroup.createValue('Unknown');

	ownerField.Mutator.init(builder.options);
	ownerField.Mutator.cloneable(IkeCloneable.ALL);

	return ownerField;
}
